import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { User } from '@/types/user';

export interface UserState {
  user: User | null;
}

interface StateWithUser {
  user: UserState;
}

const initialState: UserState = {
  user: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User | null>) {
      state.user = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;

export const selectCurrentUser = (state: StateWithUser) => state.user.user;

export default userSlice.reducer;
